import { useEffect, useMemo, useState } from "react"

const useForm = (initialForm = {}, formValidations = {}) => {
    const [ formState, setFormState ] = useState( initialForm )
    const [ formValidation, setFormValidation ] = useState([])

    const [elementResetFlag, setElementResetFlag] = useState(false); //para select-lists mediante su `key`

    useEffect(() => {
        createValidators()
    }, [ formState ])

    useEffect(() => {
        setFormState(initialForm)
    }, [ initialForm ])

    const isFormValid = useMemo( () => {
        for (const formValue of Object.values( formValidation )) {
            if (formValidation[formValue] !== null ) return false
        }
        return true
    }, [ formValidation ])

    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const onInputChangeForNumber = ({ target }) => {

        const { name, value } = target;

        const cleanValue = value.replace(/,/g, '');

        const validNumber = /^-?\d*\.?\d*$/.test(cleanValue);

        if (!validNumber) {
            return;
        }

        if (cleanValue === '' || cleanValue === '.') {
            setFormState({
                ...formState,
                [name]: value,
                [`clean_${name}`]: parseFloat(cleanValue) 
            });
            return;
        }

        let [integerPart, decimalPart] = cleanValue.split('.');

        if (decimalPart !== undefined) {
            decimalPart = decimalPart.slice(0, 2); 
        }

        const formattedInteger = numberFormatter.format(parseFloat(integerPart || 0));

        const formattedValue = decimalPart !== undefined
            ? `${formattedInteger}.${decimalPart}` 
            : formattedInteger; 

        setFormState({
            ...formState,
            [name]: formattedValue,
            [`clean_${name}`]: parseFloat(cleanValue) 
        });

    }

    const onInputChange = ({ target }) => {
        const { name, value } = target
        setFormState({
            ...formState,
            [ name ]: value
        })
    }

    const onInputChangeFiles = ({ target }) => {
        const { name, files } = target
        setFormState({
            ...formState,
            [ name ]: files[0]
        })
    }

    const onResetForm = () => {
        setFormState( initialForm )
        setElementResetFlag(prevFlag => !prevFlag); //para select-lists mediante su `key`
    }

    const createValidators = () => {
        const formCheckedValues = {}

        for(const formField of Object.keys( formValidation )) {
            const [ fn, errorMessage ] = formValidation[formField]

            formCheckedValues[`${ formField }Valid`] = fn( formState[formField] ) ? null : errorMessage
        }

        setFormValidation( formCheckedValues )
    }

    return {
        ...formState,
        formState,
        elementResetFlag,
        onInputChange,
        onInputChangeFiles,
        onResetForm,
        ...formValidation,
        isFormValid,
        onInputChangeForNumber,
        setFormState,
        numberFormatter
    }

}


export {
    useForm
}